'use strict'

import { yieldToMain } from 'assets/core/js/common'
import HashManager from 'assets/core/js/module/hashManager'
import budgetSlider from 'assets/core/js/page/product/budgetSlider'
import productCalendar from 'assets/core/js/page/product/search/calendar'
import { Facets } from 'assets/core/js/page/product/search/facets'
import filters, { setFiltersFromHash } from 'assets/core/js/page/product/search/filters'
import partialEvents, { updatePartials } from 'assets/core/js/page/product/search/partialEvents'
import { setCapacity } from 'assets/core/js/page/product/search/utils/capacity'
import { setDate } from 'assets/core/js/page/product/search/utils/date'
import { setNights } from 'assets/core/js/page/product/search/utils/night'

export default function (facets: Facets): void {
  filters(facets)
  partialEvents(facets)
  budgetSlider('filter-offers', false)
  productCalendar(updatePartials)

  let capacityValue = HashManager.getParameter<string>('capacity')
  let nightValue = HashManager.getParameter<string>('night')
  let dateValue = HashManager.getParameter<string>('checkInDate')

  if (dateValue && nightValue) {
    setDate(dateValue, nightValue)
  }

  if (capacityValue) {
    setCapacity(capacityValue)
  }

  if (nightValue) {
    // we need to set the nights after the calendar is initialized as the calendar can init the nights field
    setNights(nightValue)
  }

  // don't update partials if all parameters are empty
  if (![dateValue, capacityValue, nightValue].every((value) => value === '' || value === null)) {
    // calling updatePartials will update hash, call for the partials to update and set the appropriate filters
    updatePartials()
  } else {
    void (async () => {
      await setFiltersFromHash(facets)
    })()
  }

  const searchAvailabilityForm = document.getElementById('search-availability-form')

  if (searchAvailabilityForm !== null) {
    document.addEventListener('change', function (e: Event) {
      const target = e.target as HTMLElement
      const detail = (e as CustomEvent).detail as {
        src: string
      }

      const idsToUpdate = ['capacity', 'capacity_traveler_selector']

      if (idsToUpdate.includes(target.id)) {
        if (!detail || (detail && detail.src !== 'setValues')) {
          void (async () => {
            await yieldToMain()
            updatePartials()
          })()
        }
      }
    })
  }

  window.addEventListener(
    'hashchange',
    () => {
      const hash = window.location.hash.match(/#/)
      if (!hash) {
        window.location.reload()
        return
      }

      HashManager.stopUpdatingHash()
      HashManager.parseHash()

      let update = false

      const newDateValue = HashManager.getParameter('checkInDate') as string
      const newNightValue = HashManager.getParameter('night') as string
      const newCapacityValue = HashManager.getParameter('capacity') as string

      if (capacityValue !== newCapacityValue || dateValue !== newDateValue || nightValue !== newNightValue) {
        update = true
      }

      dateValue = newDateValue
      nightValue = newNightValue
      capacityValue = newCapacityValue

      setDate(dateValue, nightValue)
      setNights(nightValue)
      setCapacity(capacityValue)

      if (update) {
        updatePartials()
      } else {
        void (async () => {
          await setFiltersFromHash(facets)
        })()
      }

      HashManager.startUpdatingHash()
    },
    false
  )
}
